import ServiceTemplate from '@/components/ServiceTemplate';

export default function NomineeDirector() {
  const data = {
    title: 'Nominee Director Services',
    subtitle: 'Professional nominee director services for corporate governance requirements.',
    overviewTitle: 'What is a Nominee Director?',
    overviewImage: 'https://images.unsplash.com/photo-1758518731224-100f6a30bffc',
    description: [
      'Nominee directors serve on corporate boards to meet governance requirements, provide independence, or maintain privacy while actual control remains with beneficial owners. These arrangements are common in international business structures.',
      'Our nominee director service provides qualified professionals to serve as directors, handling board responsibilities while following beneficial owner instructions within legal and fiduciary boundaries.',
      'We ensure compliance with corporate law requirements while maintaining proper governance and protecting all parties through clear agreements and documentation.'
    ],
    benefits: [
      { title: 'Governance Compliance', description: 'Meet board composition requirements.' },
      { title: 'Professional Service', description: 'Qualified directors with relevant experience.' },
      { title: 'Privacy Protection', description: 'Maintain beneficial owner privacy.' },
      { title: 'Fiduciary Standards', description: 'Directors fulfill proper fiduciary duties.' },
      { title: 'Clear Agreements', description: 'Documented relationships and responsibilities.' },
      { title: 'Ongoing Support', description: 'Continuous director services.' }
    ],
    process: [
      { title: 'Initial Setup & Assessment', description: 'Comprehensive evaluation of current situation and establishment of service framework.' },
      { title: 'Implementation & Management', description: 'Execute ongoing services with regular monitoring, reporting, and optimization.' },
      { title: 'Review & Strategic Guidance', description: 'Periodic reviews with strategic recommendations for continuous improvement.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential formation',
        price: '$299',
        period: '+ state fees',
        features: [
          'Entity formation filing',
          'Name availability check',
          'EIN application',
          'Basic documents',
          'Email support',
          'Document delivery'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete package',
        price: '$599',
        period: '+ state fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Custom agreements',
          'Tax consultation',
          'Compliance setup',
          'Registered agent (1 year)',
          'Priority processing',
          'Phone support'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Full-service solution',
        price: '$999',
        period: '+ state fees',
        features: [
          'Everything in Professional',
          'Multi-state filing',
          'Advanced structuring',
          'Annual compliance',
          'Quarterly reviews',
          'Dedicated attorney',
          'Unlimited consultations'
        ]
      }
    ],
    faqs: [
      { question: 'What does a nominee director do?', answer: 'Nominee directors serve on the board, attend meetings, sign documents, and fulfill legal director responsibilities while following beneficial owner instructions within legal bounds.' },
      { question: 'Is this legal?', answer: 'Yes, nominee directors are legal when properly structured with clear agreements and compliance with fiduciary duties and corporate law.' },
      { question: 'Who controls the company?', answer: 'Beneficial owners retain control through shareholder rights, though nominee directors have independent fiduciary duties to the company.' },
      { question: 'What are fiduciary duties?', answer: 'Directors owe duties of care and loyalty to the company. Nominee directors must balance following instructions with legal obligations.' },
      { question: 'How much does it cost?', answer: 'Nominee director fees vary based on jurisdiction, company complexity, and level of involvement required.' },
      { question: 'What liability does the nominee director have?', answer: 'Directors can face personal liability for wrongful acts. Proper agreements, insurance, and indemnification protect nominee directors.' },
      { question: 'Can nominee directors sign contracts?', answer: 'Yes, as board members they can sign contracts and documents on behalf of the company with proper authorization.' },
      { question: 'What documentation is required?', answer: 'Nominee agreements clearly defining relationships, responsibilities, indemnification, and limitations are essential for all parties\' protection.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
